'use client'

import { ShoppingCartIcon } from '@heroicons/react/24/outline'
import Link from 'next/link'
import { useHeaderShoppingCart } from '@/ShoppingCart/useHeaderShoppingCart'

export const CartButton = () => {
  const { totalQuantity } = useHeaderShoppingCart()

  return (
    <div>
      <Link
        href="/checkout"
        aria-label="Cart"
        className="relative inline-flex min-h-[44px] min-w-[44px] cursor-pointer items-center justify-center rounded-md px-2 py-2 font-semibold text-vi-gray hover:text-vi-red ring-gray-300 hover:bg-gray-50"
      >
        <ShoppingCartIcon className="h-6 w-6" aria-hidden="true" />
        {totalQuantity > 0 && (
          <div
            key={totalQuantity}
            className="text-[11px] absolute top-0 right-0 flex items-center justify-center bg-green-600 text-white rounded-full w-[20px] h-[20px] animate-fade-in-down ease-in-out duration-1000"
          >
            {totalQuantity}
          </div>
        )}
        <span className="sr-only">view items in cart</span>
      </Link>
    </div>
  )
}
